import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { colors, fonts, leading } from '../../styles/theme';

export const Error = styled('div')`
  font-family: ${fonts.sans.family};
  font-size: ${fonts.sans.size.small};
  text-align: left;
  color: ${colors.red.primary};
  margin-top: ${leading.eighth};
  display: none;
`;

const errorStyles = css`
  border-color: ${colors.red.primary};
  input,
  textarea,
  .react-tabs__tab-panel--selected {
    border-color: ${colors.red.primary};
    &:focus,
    &:hover {
      border-color: ${colors.red.primary};
    }
  }
  ${Error} {
    display: block;
  }
`;

const ErrorContainer = styled('div')`
  ${(props) => (props.error && props.touched ? errorStyles : '')};
`;

export const ErrorWrapper = (props) => {
  const { error, touched, children } = props;

  return (
    <ErrorContainer touched={touched} error={error}>
      {children}
      <Error>{error}</Error>
    </ErrorContainer>
  );
};

ErrorWrapper.defaultProps = {
  error: null,
  touched: false,
};

ErrorWrapper.propTypes = {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.bool), PropTypes.string]),
  touched: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.bool)]),
  children: PropTypes.element.isRequired,
};
